import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutPageComponent } from '@core/pages/layout-page.component';
import { UnderConstructionPageComponent } from '@core/pages/under-construction-page.component';
import { NotFoundPageComponent } from '@core/pages/not-found-page.component';
import { AuthorizationDeniedPageComponent } from '@core/pages/authorization-denied-page.component';

const routes: Routes = [
  {
    path: 'front-plugin',
    loadChildren: () =>
      import('./features/front-plugin/front-plugin.module').then(
        (m) => m.FrontPluginModule
      ),
  },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: 'authorization-denied',
    component: AuthorizationDeniedPageComponent,
    data: {
      url: '/authorization-denied',
      title: 'Authorization Denied',
      icon: 'security',
      show: false,
      seq: 6
    }
  },
  {
    path: 'under-construction',
    component: UnderConstructionPageComponent,
    data: {
      url: '/under-construction',
      title: 'Under Construction',
      icon: 'warning',
      show: false,
      seq: 4
    }
  },
  {
    path: 'not-found',
    component: NotFoundPageComponent,
    data: {
      url: '/not-found',
      title: 'Not Found',
      icon: 'sms_failed',
      show: false,
      seq: 5
    }
  },
  {
    path: '',
    component: LayoutPageComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./features/home/home.module').then(m => m.HomeModule),
        data: {
          url: '/home',
          title: 'Home',
          icon: 'home',
          show: false,
          showExpansion: false,
          seq: 0,
          controlTowerItem: false,
          customsItem: false,
          roles: ['UserManagement', 'Administrator', 'Manager', 'User', 'Customer', 'CustomerAdmin']
        }
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardModule),
        data: {
          url: '/dashboard',
          title: 'Dashboard',
          icon: 'widgets',
          show: true,
          showExpansion: true,
          seq: 1,
          roles: ['UserManagement', 'Administrator', 'Manager', 'User']
        }
      },
      {
        path: 'control-tower-dashboard',
        loadChildren: () => import('./features/control-tower-dashboard/control-tower-dashboard.module').then(m => m.ControlTowerDashboardModule),
        data: {
          url: '/control-tower-dashboard',
          title: 'Control Tower Dashboard',
          icon: 'widgets',
          show: true,
          showExpansion: false,
          controlTowerItem: true,
          customsItem: false,
          seq: 1,
          roles: ['ControlTower','ControlTowerUser']
        }
      },
      {
        path: 'tours',
        loadChildren: () => import('./features/managed-tours/managed-tours.module').then(m => m.ManagedToursModule),
        data: {
          url: '/tours',
          title: 'Shipments',
          icon: 'list',
          show: true,
          showExpansion: true,
          seq: 2,
          roles: ['ControlTower','ControlTowerUser', 'UserManagement', 'Administrator', 'Manager', 'User']
        }
      },
      {
        path: 'control-tower-escalation',
        loadChildren: () => import('./features/control-tower-escalation/control-tower-escalation.module').then(m => m.ControlTowerEscalationModule),
        data: {
          url: '/control-tower-escalation',
          title: 'Control Tower Escalation',
          icon: 'list',
          show: true,
          showExpansion: false,
          controlTowerItem: true,
          customsItem: false,
          seq: 3,
          roles: ['ControlTower', 'UserManagement', 'Administrator', 'Manager', 'User']
        }
      },
      {
        path: 'adminTours',
        loadChildren: () => import('./features/admin-tours/admin-tours.module').then(m => m.AdminToursModule),
        data: {
          url: '/adminTours',
          title: 'Shipments Admin',
          icon: 'list',
          show: true,
          showExpansion: true,
          seq: 4,
          roles: ['TourAdmin']
        }
      },
      {
        path: 'my-tours',
        loadChildren: () => import('./features/my-tours/my-managed-tours.module').then(m => m.MyManagedToursModule),
        data: {
          url: '/my-tours',
          title: 'My Shipments',
          icon: 'list',
          show: false,
          showExpansion: true,
          seq: 2,
          roles: ['Customer',  'CustomerAdmin']
        }
      },
      {
        path: 'control-tower-live-map',
        loadChildren: () => import('./features/control-tower-map/control-tower-map.module').then(m => m.ControlTowerMapModule),
        data: {
          url: '/control-tower-live-map',
          title: 'Control Tower Live Map',
          icon: 'map',
          show: true,
          showExpansion: false,
          controlTowerItem: true,
          customsItem: false,
          seq: 2,
          roles: ['ControlTower','ControlTowerUser']
        }
      },
      {
        path: 'tour-history',
        loadChildren: () => import('./features/tour-history/tour-history.module').then(m => m.TourHistoryModule),
        data: {
          url: '/tour-history',
          title: 'Shipment History',
          icon: 'history',
          show: true,
          showExpansion: true,
          seq: 3,
          roles: ['UserManagement', 'Administrator', 'Manager', 'User']
        }
      },
      {
        path: 'my-tour-history',
        loadChildren: () => import('./features/my-tour-history/my-tour-history.module').then(m => m.MyTourHistoryModule),
        data: {
          url: '/my-tour-history',
          title: 'My Shipment History',
          icon: 'history',
          show: true,
          showExpansion: true,
          seq: 4,
          roles: ['Customer','CustomerAdmin']
        }
      },
      {
        path: 'active-tours',
        loadChildren: () => import('./features/active-tours/active-tours.module').then(m => m.ActiveToursModule),
        data: {
          url: '/active-tours',
          title: 'Active Shipments',
          icon: 'check',
          show: false,
          showExpansion: true,
          seq: 3,
          roles: ['Customer','CustomerAdmin']
        }
      },
      {
        path: 'my-active-tours',
        loadChildren: () => import('./features/my-active-tours/my-active-tours.module').then(m => m.MyActiveToursModule),
        data: {
          url: '/my-active-tours',
          title: 'My Active Shipments',
          icon: 'check',
          show: true,
          showExpansion: true,
          seq: 3,
          roles: ['Customer','CustomerAdmin']
        }
      },
      {
        path: 'log-tickets',
        loadChildren: () => import('./features/log-tickets/log-tickets.module').then(m => m.LogTicketsToursModule),
        data: {
          url: '/log-tickets',
          title: 'Tickets',
          icon: 'confirmation_number',
          show: true,
          showExpansion: false,
          seq: 5,
          controlTowerItem: false,
          customsItem: false,
          roles: ['UserManagement', 'Administrator', 'Manager', 'User']
        }
      },

      {
        path: 'quotes',
        loadChildren: () => import('./features/quotes/quotes.module').then(m => m.QuotesModule),
        data: {
          url: '/quotes',
          title: 'Quotes',
          icon: 'request_quote',
          show: true,
          showExpansion: false,
          seq: 0,
          controlTowerItem: false,
          customsItem: false,
          roles: ['Administrator','Quotes']
        }
      },
      {
        path: 'geofencing',
        loadChildren: () => import('./features/geofencing/geofencing.module').then(m => m.GeofencingModule),
        data: {
          url: '/geofencing',
          title: 'Geofencing',
          icon: 'location_on',
          show: true,
          showExpansion: false,
          seq: 0,
          controlTowerItem: false,
          customsItem: false,
          roles: ['FeatureRole']
        }
      },
     /*  {
        path: '',
        loadChildren: () => import('./features/home/home.module').then(m => m.HomeModule),
        data: {
          url: '/quotes',
          title: 'Quotes',
          icon: 'request_quote',
          show: true,
          showExpansion: false,
          seq: 0,
          controlTowerItem: false
          customsItem: false,,
          roles: ['FeatureRole', 'Administrator']
        }
      }, */
      {
        path: '',
        loadChildren: () => import('./features/home/home.module').then(m => m.HomeModule),
        data: {
          url: '/orders',
          title: 'Orders',
          icon: 'grading',
          show: true,
          showExpansion: false,
          seq: 0,
          controlTowerItem: false,
          customsItem: false,
          roles: ['FeatureRole']
        }
      },
      {
        path: 'customs-dashboard',
        loadChildren: () => import('./features/customs-dashboard/customs-dashboard.module').then(m => m.CustomsDashboardModule),
        data: {
          url: '/customs-dashboard',
          title: 'Customs Dashboard',
          icon: 'widgets',
          show: true,
          showExpansion: false,
          seq: 0,
          controlTowerItem: false,
          customsItem: true,
          roles: ['Customs']
        }
      },
      {
        path: 'customs-listing',
        loadChildren: () => import('./features/customs-listing/customs-listing.module').then(m => m.CustomsListingModule),
        data: {
          url: '/customs-listing',
          title: 'Customs Live',
          icon: 'list',
          show: true,
          showExpansion: false,
          seq: 1,
          controlTowerItem: false,
          customsItem: true,
          roles: ['Customs', 'Customer','CustomerAdmin']
        }
      },
      {
        path: 'customs-history',
        loadChildren: () => import('./features/customs-history/customs-history.module').then(m => m.CustomsHistoryModule),
        data: {
          url: '/customs-history',
          title: 'Customs History',
          icon: 'history',
          show: true,
          showExpansion: false,
          seq: 2,
          controlTowerItem: false,
          customsItem: true,
          roles: ['Customs', 'Customer','CustomerAdmin']
        }
      },
      {
        path: '',
        loadChildren: () => import('./features/home/home.module').then(m => m.HomeModule),
        data: {
          url: '/warehousing',
          title: 'Warehousing',
          icon: 'source_environment',
          show: true,
          showExpansion: false,
          seq: 0,
          controlTowerItem: false,
          customsItem: false,
          roles: ['FeatureRole']
        }
      },
      {
        path: '',
        loadChildren: () => import('./features/home/home.module').then(m => m.HomeModule),
        data: {
          url: '/invoicing',
          title: 'Invoicing',
          icon: 'description',
          show: true,
          showExpansion: false,
          seq: 0,
          controlTowerItem: false,
          customsItem: false,
          roles: ['FeatureRole']
        }
      },
      {
        path: '',
        loadChildren: () => import('./features/home/home.module').then(m => m.HomeModule),
        data: {
          url: '/kpi',
          title: 'KPIs',
          icon: 'star',
          show: true,
          showExpansion: false,
          seq: 0,
          controlTowerItem: false,
          customsItem: false,
          roles: ['FeatureRole']
        }
      },
      {
        path: '',
        loadChildren: () => import('./features/home/home.module').then(m => m.HomeModule),
        data: {
          url: '/accounts',
          title: 'Account Management',
          icon: 'inventory_2',
          show: true,
          showExpansion: false,
          seq: 0,
          controlTowerItem: false,
          customsItem: false,
          roles: ['FeatureRole']
        }
      },
      {
        path: 'users',
        loadChildren: () => import('./features/users/users.module').then(m => m.UsersModule),
        data: {
          url: '/users',
          title: 'Users',
          icon: 'supervised_user_circle',
          show: true,
          showExpansion: false,
          seq: 10,
          controlTowerItem: false,
          customsItem: false,
          roles: ['UserManagement','CustomerAdmin']
        }
      },
      {
        path: 'reports',
        loadChildren: () => import('./features/reports/report.module').then(m => m.ReportModule),
        data: {
          url: '/reports',
          title: 'Reports',
          icon: 'timeline',
          show: true,
          showExpansion: false,
          seq: 11,
          controlTowerItem: false,
          customsItem: false,
          roles: ['UserManagement', 'Administrator']
        }
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'not-found',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
